/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Ivan Ryabov
 */
import React, { Component } from 'react'

import './ColorPicker.css'

export default class ColorPicker extends Component {

    constructor(props) {
        super(props)

        this.state = {
            value: this.props.value || null,
            open: false
        }

        this.close = this.close.bind(this)
        this.toggle = this.toggle.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.value !== nextProps.value) {
            this.setState({
                value: nextProps.value
            })
        }
    }

    render() {
        let colors = null
        
        if (this.props.colors) {
            colors = this.props.colors.map((c, ix) => {
                const activeClass = c === this.state.value ? 'active' : ''
                return (<i key={ix} className={`color-item ${activeClass}`} onClick={ () => {this.choose(c)} } style={ {backgroundColor: c} }/>)
            })
        }

        let openedClass = this.state.open ? 'opened' : 'closed'

        var normalizedValue = this.state.value
        if (normalizedValue == null) {
            normalizedValue = ''
        } else if (normalizedValue.toLowerCase) {
            normalizedValue = normalizedValue.toLowerCase()
        }

        const activeClass = this.state.value === null ? 'active' : ''

        const grayClass = (normalizedValue === '#ffffff' || normalizedValue === 'white') ? 'gray' : ''

        return (
            <div className="ColorPicker">
                {this.state.value ? <svg className={`input ${grayClass}`} onClick={this.toggle}>
                    <path fill={this.state.value} d="M17.868771,10 C16.3484917,10.4009292 10.1409779,12.7894379 9.15340429,13.6643373 C8.87528773,13.9098716 4.62392551,24.0312901 3.00356888,26.2611059 C2.81294998,26.5641381 10.3157732,29.3737776 11.7113358,29.9207886 L11.7113358,48 L34.2887316,48 L34.2887316,29.9207886 C35.6824543,29.3737776 43.1852935,26.5656816 42.9964985,26.2611059 C41.3762219,24.0310912 37.1246557,13.9097961 36.8466631,13.6643373 C35.8591695,12.7894379 29.6516557,10.4024808 28.1312964,10 C27.0172462,14.2066142 18.9831412,14.2034316 17.869171,10 L17.868771,10 Z" id="Shape-Copy-2"></path>
                </svg> : <div className="empty" onClick={this.toggle}></div>}
                <div className={`wrapper ${openedClass}`}><i className={`color-item empty ${activeClass}`} onClick={ () => {this.choose(null)} }/>{colors}</div>
                <div className={`backdrop ${openedClass}`} onClick={this.close}></div>
            </div>
        )
    }

    close() {
        this.setState({
            open: false
        })
    }

    toggle() {
        this.setState({
            open: !this.state.open
        })
    }

    choose(color) {
        this.setState({
            value: color
        })
        this.props.onChange && this.props.onChange({currentTarget: {value: color}})
        this.close()
    }
}
